/* eslint-disable react/jsx-no-target-blank */
import { FC } from 'react'
import AccountsAndServiceLocationsTab from '../../../../../mogul/left-navigation/AccountsAndServiceLocationsTab'
import { useAuth } from '../../../../../app/modules/auth'

type Props = {
  link: string
}

const TabsBase: FC<Props> = ({ link }) => {
  const { currentUser } = useAuth()

  if (!currentUser) {
    return null
  }

  return <AccountsAndServiceLocationsTab isAdmin={currentUser.is_admin} />

}

export { TabsBase }
